import { css } from 'styled-components';
import { COLORS } from '../../../../shared/design/tokens';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
  `,
  createSeparateInvoiceContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    border: 1px dashed ${COLORS.INSTANCES_CONFIGURATION.BORDER};
    background-color: ${COLORS.INSTANCES_CONFIGURATION.BACKGROUND};
    margin: auto;
    text-align: center;
    cursor: pointer;

    &:hover {
      opacity: 0.75;
    }
  `,
  labelContainer: css`
    margin-top: 4px;
    margin-left: 12px;
    cursor: pointer;
  `,
  createSeparateInvoiceLabel: css`
    cursor: pointer;
  `
};

export default styles;
